import { Component } from 'react'

import styles from './Paginator.module.css'

export default class Paginator extends Component {
  state = {
    currentNumberOfItems: this.props.minNumberOfItems
  }
  handleLoadMoreItems = () => {
    this.setState({
      currentNumberOfItems: this.state.currentNumberOfItems + this.props.paginationLimit
    })
  }
  render() {
    const { children, loadMoreButtonText, loadMoreButtonClass, fallback } = this.props
    const { currentNumberOfItems } = this.state

    if (children.length === 0) {
      return fallback ? fallback : 'no results'
    } else {
      return (
        <>
          {children.slice(0, currentNumberOfItems)}
          {currentNumberOfItems < children.length && (
            <button onClick={this.handleLoadMoreItems} className={loadMoreButtonClass}>
              {loadMoreButtonText}
            </button>
          )}
        </>
      )
    }
  }
}
Paginator.defaultProps = {
  minNumberOfItems: 10,
  paginationLimit: 10,
  loadMoreButtonText: 'Load more results',
  loadMoreButtonClass: styles.moreResultsButton
}
